<script>
export default {
  name: 'RouterButton',
  functional: true,
  props: {
    title: {
      required: true
    },
    to: {
      required: true
    },
    classStyle: {
      default: ({
        btn: true,
        'btn-block': true,
        'btn-flat': true,
        'btn-icon': false,
        [`btn-default`]: true
      })
    },
    iconClass: {
      default: ''
    }
  },

  render (createElement, context) {
    return (
      <router-link to={context.props.to}>
        <button class={context.props.classStyle} title={context.props.title}>
            <i class={context.props.iconClass}></i>
            {context.props.title}
        </button>
      </router-link>
    )
  }
}
</script>

<style scoped>
  button {
    margin-top: 5px;
    margin-bottom: 5px;
  }
  i {
    margin-right: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Layout/RouterButton.vue